export const isFullStatic = false
export const staticPath = "/root/project/frontend/.nuxt/static-json"
export const publicPath = "https://frontenddev.builtin.com/04fa877a8574f204cfc78f7c40b083eff5c95129/"
export const globalContext = "__NUXT__"
export const globalNuxt = "$nuxt"